import React, { useContext, useState } from "react";
import "./Navbar.css";
import { FiMenu, FiX } from "react-icons/fi";
import cart_icon from "../Assets/Frontend_Assets/cart_icon.png";
import logo from "../Assets/Frontend_Assets/logo.png";
import { Link } from "react-router-dom";
import { ShopContext } from "../../Context/ShopContext";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { getTotalCartItems } = useContext(ShopContext);

  const isAuth = localStorage.getItem("auth-token");

  const handleLogout = () => {
    localStorage.removeItem("auth-token");
    window.location.replace("/");
  };

  return (
    <>
      {/* NAVBAR */}
      <div className="navbar">
        {/* LOGO */}
        <Link to="/" className="nav-logo">
          <img src={logo} alt="Prime Cosmo" />
        </Link>

        {/* DESKTOP MENU */}
        <ul className="nav-menu desktop-menu">
          <li><Link to="/">Shop</Link></li>
          <li><Link to="/beardoil">Premium Beard Oil</Link></li>
          <li><Link to="/hairoil">Hair Growth Oil</Link></li>
          <li><Link to="/soap">Goated Soaps</Link></li>
        </ul>

        {/* RIGHT */}
        <div className="nav-right">
          {/* LOGIN */}
          <div className="nav-login desktop-menu">
            {isAuth ? (
              <button onClick={handleLogout}>Logout</button>
            ) : (
              <Link to="/login">
                <button>Login</button>
              </Link>
            )}
          </div>

          {/* CART (ALWAYS VISIBLE) */}
          <div className="cart-wrapper">
            <Link to="/cart">
              <img src={cart_icon} alt="Cart" className="cart-icon" />
            </Link>
            <span className="nav-cart-count">{getTotalCartItems()}</span>
          </div>

          {/* MOBILE ICON */}
          <div className="mobile-icon" onClick={() => setOpen(true)}>
            <FiMenu />
          </div>
        </div>
      </div>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${open ? "show" : ""}`}>
        <div className="close-btn" onClick={() => setOpen(false)}>
          <FiX />
        </div>

        <ul className="mobile-links">
          <li><Link onClick={() => setOpen(false)} to="/">Shop</Link></li>
          <li><Link onClick={() => setOpen(false)} to="/beardoil">Premium Beard Oil</Link></li>
          <li><Link onClick={() => setOpen(false)} to="/hairoil">Hair Growth Oil</Link></li>
          <li><Link onClick={() => setOpen(false)} to="/soap">Goated Soaps</Link></li>
        </ul>

        {isAuth ? (
          <button className="mobile-login" onClick={handleLogout}>
            Logout
          </button>
        ) : (
          <Link to="/login" onClick={() => setOpen(false)}>
            <button className="mobile-login">Login</button>
          </Link>
        )}
      </div>
    </>
  );
};

export default Navbar;
